<app-header headerText="Parámetros Préstamos Caja De Ahorro Retiro"></app-header>

<mat-tab-group mat-align-tabs="center" animationDuration="0ms" dynamicHeight=true [selectedIndex]="selectedIndex">

  <mat-tab>

    <ng-template mat-tab-label>
      <mat-icon>edit</mat-icon>
      Editar<br>Ciclo
    </ng-template>

    <div class="row py-2 border-bottom">

      <div class="col-md-4 offset-md-4">

        <mat-form-field>
          <mat-select placeholder="Nombre del Ciclo de Ahorro a Editar:"
            (selectionChange)="selectedPeriodChange($event)" [value]="tempPeriod">
            <mat-option>Seleccione el ciclo</mat-option>
            <mat-option *ngFor="let period of savingParameters" [value]="period">
              {{period.title}}
            </mat-option>
          </mat-select>
        </mat-form-field>

      </div>
    </div>

    <!-- nuevo valos de antiguedad -->
    <div *ngIf="modParameter && editIndex < 0">

      <div *ngIf="!newLoanParameter && modParameter.loansParameters.length > 0">

        <div class="row mt-5">
          <div class="col-md-12 bottom-vertically">
            <button class="btn-block" mat-raised-button color="primary" (click)="addSeniorityRange()">Añadir</button>
          </div>
        </div>

        <div class="row">

          <div class="col-md-12">
            <mat-table #rangeTable class="table" [dataSource]="modParameter.loansParameters">
              <ng-container matColumnDef="start">
                <mat-header-cell mat-header-cell *matHeaderCellDef> Desde Año </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.applicableSeniorityRange.start}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="end">
                <mat-header-cell mat-header-cell *matHeaderCellDef> Hasta Año </mat-header-cell>
                <mat-cell mat-cell *matCellDef="let element"> {{element.applicableSeniorityRange.end}} </mat-cell>
              </ng-container>

              <ng-container matColumnDef="edit" class="center-text">
                <mat-header-cell *matHeaderCellDef><span>Editar</span></mat-header-cell>
                <mat-cell *matCellDef="let index = index">
                  <button mat-icon-button color="primary" (click)="editLoanParameter(index)">
                    <mat-icon aria-label="Edit">edit_outline</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="delete" class="center-text">
                <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
                <mat-cell *matCellDef="let index = index">
                  <button mat-icon-button color="warn" (click)="deleteParamLoan(index)">
                    <mat-icon aria-label="Delete">delete_outline</mat-icon>
                  </button>
                </mat-cell>
              </ng-container>

              <mat-header-row mat-header-row *matHeaderRowDef="seniorityRangeColumns"></mat-header-row>
              <mat-row mat-row *matRowDef="let row; columns: seniorityRangeColumns;"></mat-row>
            </mat-table>

          </div>

        </div>

      </div>
    </div>

<div *ngIf="newLoanParameter">
  <app-rl-parameters [modParameter]="newLoanParameter"></app-rl-parameters>
    <div class="row my-4">

      <div class="col-md-4 offset-md-4">
        <button class="btn btn-block btn-outline-secondary" (click)="cancelPeriodChanges()">Cancelar</button>
      </div>

      <div class="col-md-4">
        <button class="btn btn-block btn-primary" (click)="saveEditedPeriod();">Guardar Cambios</button>
      </div>

    </div>
</div>

  </mat-tab>

</mat-tab-group>